import TreatmentDetail from "@/pages/treatment/components/TreatmentDetail";
import { getTreatmentPage } from "@/mocks/treatmentPages";

export default function InjectablesPage() {
  const data = getTreatmentPage("injectables");
  if (!data) return null;
  return (
    <TreatmentDetail
      data={data}
      // 今回のLPはボトックス対象のため「注入治療全体のモニター」と誤認させない名称にする
      monitorLp={{
        title: "初めての方限定・ボトックスモニターのご案内",
        description:
          "初めてご来院いただく方向けのボトックスモニターの内容・条件は、専用ページでご案内しています。",
        label: "ボトックスモニターを見る",
        url: "https://sbscl.biz/botox/#reservation",
      }}
    />
  );
}